<ng-template #myModal>
  <form
    (ngSubmit)="submitTime()"
    [formGroup]="timeCorrectionForm"
    (keydown.enter)="$event.preventDefault()">
    <div class="modal-custom">
      <div class="modal-custom__header">
        <h4>ЗАВЕРШИТЬ?</h4>
      </div>
      <div class="modal-custom__body">
        <ul class="modal-custom__body__list">
          <li>{{ lesson.subject_obj.title }}</li>
          <li>Занятие № {{ lesson.lesson_number }}</li>
        </ul>
        <div class="modal-custom__body__time-correction">
          <div class="toggle-button" (click)="isTimeCorrectionFormOpen = !this.isTimeCorrectionFormOpen">
            Корректировка времени <i class="fa fa-caret-down {{isTimeCorrectionFormOpen ? 'rotate' : ''}}"></i>
          </div>
          <div id="timeCorrection" *ngIf="isTimeCorrectionFormOpen">
            <div class="container-fluid">
              <div class="modal-custom__form">
                <div class="row justify-content-center">
                  <div class="col-5">
                    <div class="form-inline">
                      <div class="form-group form-group-sm">
                        <div class="d-inline-block modal-custom__form__label modal-custom__form__label_small">
                          Дата:
                        </div>
                        <input type="date"
                               class="form-control modal-custom__form__input modal-custom__form__input_date"
                               title="Выберите дату"
                               formControlName="lessonDate">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="modal-custom__form_flex mt-3">
                      <div class="input_time__wrapper">
                        <div class="input_time__wrapper__label">
                          Старт:
                        </div>
                        <div class="input_time input_time__start">
                          <div>
                            <input
                              type="number"
                              class="form-control input_time__input"
                              title="Час"
                              (keypress)="checkTimeInput($event)"
                              (change)="refreshDuration()"
                              [max]="23"
                              [min]="0"
                              formControlName="startTimeHour">
                          </div>
                          <div class="time-divider"></div>
                          <div>
                            <input
                              type="number"
                              class="form-control input_time__input"
                              title="Минут"
                              (keypress)="checkTimeInput($event)"
                              (change)="refreshDuration()"
                              [max]="59"
                              [min]="0"
                              formControlName="startTimeMinute">
                          </div>
                        </div>
                        <div class="input_time__wrapper__hints">
                          <span class="hint">час</span>
                          <span class="hint">мин</span>
                        </div>
                      </div>
                      <div class="">
                        <div class="modal-custom__form__label modal-custom__form__label_small">
                          Длительность <i>(минут):</i>
                        </div>
                        <div class="modal-custom__time-circle">
                          <app-circle-progressbar
                            progressBarColor="#ffffff"
                            fontColor="#495660"
                            [maxValue]="60"
                            [progressValue]="durationTime"
                            [fontSize]="30"
                            [diameter]="90">
                          </app-circle-progressbar>
                        </div>
                      </div>
                      <div class="">
                        <div class="input_time__wrapper">
                          <div class="input_time__wrapper__label">
                            Финиш:
                          </div>
                          <div class="input_time input_time__end">
                            <div>
                              <input
                                type="number"
                                class="form-control input_time__input"
                                title="Час"
                                (keypress)="checkTimeInput($event)"
                                (change)="refreshDuration()"
                                [max]="23"
                                [min]="0"
                                formControlName="endTimeHour">
                            </div>
                            <div class="time-divider"></div>
                            <div>
                              <input
                                type="number"
                                class="form-control input_time__input"
                                title="Минут"
                                (keypress)="checkTimeInput($event)"
                                (change)="refreshDuration()"
                                [max]="59"
                                [min]="0"
                                formControlName="endTimeMinute">
                            </div>
                          </div>
                          <div class="input_time__wrapper__hints">
                            <span class="hint">час</span>
                            <span class="hint">мин</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-custom__footer">
        <div class="modal-custom__footer__button">
          <button type="button" class="btn button_mode_cancel" [ngClass]="buttonModifier" (click)="decline($event)">{{textButtonDecline}}</button>
        </div>
        <div class="modal-custom__footer__button">
          <button type="submit" class="btn button" [disabled]="timeCorrectionForm.invalid && isTimeCorrectionFormOpen">
            <span *ngIf="isTimeCorrectionFormOpen">{{textButtonTextSave}}</span>
            <span *ngIf="!isTimeCorrectionFormOpen">{{textButtonTextConfirm}}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</ng-template>
